import Chip from 'lib/Chip';
import { Size } from 'lib/Chip/Chip.types';
import { CreativeStatusBadge } from 'consts/creative';

type StatusRendererProps = {
  value: string;
  statuses: CreativeStatusBadge[];
  chipSize?: Size;
  isTruncatedLabel?: boolean;
};

const StatusRenderer = ({
  value,
  statuses,
  chipSize = Size.MEDIUM,
  isTruncatedLabel,
}: StatusRendererProps): React.ReactElement => {
  const { color, name } = statuses.find((status) => status.code === value) || {};
  return <Chip label={name} color={color} size={chipSize} truncateLabel={isTruncatedLabel} />;
};

export default StatusRenderer;
